import { UseQueryResult } from '@tanstack/react-query';
import { Setting, SettingsApi } from 'oas/userconfig';
import { useApiQuery } from '../use-api-query';
import { rethrowSwallowedError } from '../use-api-mutation';
import { API_NAMES } from '../constants';

// don't retry requests to user config if the service is down
const SINGLE_ATTEMPT = {
    retry: false,
    retryOnMount: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
};

export const useGetUserConfigSettings = (keyPrefix?: string, options = {}): UseQueryResult<Setting[]> => {
    return useApiQuery(
        ['user-config', 'settings', keyPrefix],
        (apiConfig, axiosInstance) =>
            new SettingsApi(apiConfig, '', axiosInstance).getSettings(keyPrefix).then(rethrowSwallowedError),
        { ...SINGLE_ATTEMPT, ...options },
        'v6',
        API_NAMES.USER_CONFIG,
    );
};

export const useGetUserConfigSetting = (settingKey: string, options = {}): UseQueryResult<Setting> => {
    return useApiQuery(
        ['user-config', 'setting', settingKey],
        (apiConfig, axiosInstance) =>
            new SettingsApi(apiConfig, '', axiosInstance).getSetting(settingKey).then(rethrowSwallowedError),
        { ...SINGLE_ATTEMPT, ...options },
        'v6',
        API_NAMES.USER_CONFIG,
    );
};
